/**
 * PSA Channel Index Engine
 * ========================
 * Provides pure-DOM sorting, filtering, and topic badge hydration 
 * for channel index pages (e.g., /philippines/briefs/cyber-risks/).
 * 
 * Loaded globally via assets/built/index.js but automatically terminates 
 * if executed on a non-channel page.
 */

document.addEventListener('DOMContentLoaded', function () {

    var gridEl = document.getElementById('psa-channel-grid');
    if (!gridEl) return; // Guard: Stop execution if not on a channel grid

    // CHANNEL TAG SLUG: Extract the top-level route (e.g. 'briefs' or 'reports') 
    // to exclude it from the dynamically populated filter dropdown.
    var parts = window.location.pathname.split('/').filter(Boolean);
    if (parts.length < 2) return;
    var channel = { tag: parts[1] };

    // DOM References for controls
    var sortSelect   = document.getElementById('psa-sort-select');
    var filterSelect = document.getElementById('psa-filter-select');
    var paginationEl = document.getElementById('psa-server-pagination');
    var resultsEl    = document.getElementById('psa-results-count');

    var currentSort   = 'published_at desc';
    var currentFilter = 'all';

    // 1. TOPIC BADGE HYDRATION
    // Inspects the raw 'data-tags' attribute on server-rendered cards. Finds
    // the first matching non-channel tag, and injects it into `.psa-topic-badge`.
    function hydrateTopicTags() {
        if (!channel || !gridEl) return;
        var cards = gridEl.querySelectorAll('article[data-tags]');
        cards.forEach(function (card) {
            var raw = card.getAttribute('data-tags') || '';
            if (!raw) return;
            
            var tags = raw.split(',').map(function (p) {
                var idx = p.indexOf('|');
                return idx > -1 ? { slug: p.slice(0, idx), name: p.slice(idx + 1) } : null;
            }).filter(Boolean);
            
            var topic = tags.find(function (t) { return t.slug !== channel.tag; });
            if (topic) {
                var badge = card.querySelector('.psa-topic-badge');
                if (badge) {
                    badge.textContent = topic.name;
                    badge.className = 'psa-topic-badge mr-auto inline-block text-[10px] font-semibold uppercase tracking-wider text-psa-blue bg-blue-50 rounded px-2 py-0.5';
                }
            }
        });
    }
    
    // Immediately run topic tag hydration
    hydrateTopicTags();

    // 2. POPULATE FILTER DROPDOWN
    // Scans all successfully rendered cards to aggregate filterable tags dynamically.
    function populateFiltersFromDOM() {
        if (!filterSelect || !gridEl) return;
        
        var tagsMap = {};
        var cards = gridEl.querySelectorAll('article[data-tags]');
        
        cards.forEach(function(card) {
            var raw = card.getAttribute('data-tags') || '';
            if (!raw) return;
            
            var tags = raw.split(',').map(function (p) {
                var idx = p.indexOf('|');
                return idx > -1 ? { slug: p.slice(0, idx), name: p.slice(idx + 1) } : null;
            }).filter(Boolean);
            
            tags.forEach(function(tag) {
                if (tag.slug === channel.tag) return; // Skip primary channel tag
                if (!tagsMap[tag.slug]) {
                    tagsMap[tag.slug] = { name: tag.name, count: 0 };
                }
                tagsMap[tag.slug].count++;
            });
        });
        
        // Sort tags alphabetically
        var sortedSlugs = Object.keys(tagsMap).sort(function(a, b) {
            return tagsMap[a].name.localeCompare(tagsMap[b].name);
        });
        
        sortedSlugs.forEach(function(slug) {
            var opt = document.createElement('option');
            opt.value = slug;
            opt.textContent = tagsMap[slug].name + ' (' + tagsMap[slug].count + ')';
            filterSelect.appendChild(opt);
        });
    }
    
    // Immediately populate filter dropdown options
    if (filterSelect) populateFiltersFromDOM();

    // 3. SORT & FILTER VIA PURE DOM MANIPULATION
    // Reorders and toggles display mode on flex card elements without 
    // requiring any server API calls.
    function applyDOMFilterAndSort() {
        if (!gridEl) return;
        
        var cards = Array.from(gridEl.querySelectorAll('article.group'));
        var visibleCount = 0;
        
        // Sort Phase: Parse timestamps
        cards.forEach(function(card, idx) {
            var timeEl = card.querySelector('time');
            card._i = idx; // Preserve original DOM load order
            if (timeEl && timeEl.getAttribute('datetime')) {
                card._ts = new Date(timeEl.getAttribute('datetime')).getTime();
            } else {
                card._ts = 0;
            }
        });
        
        // Array sort based on selected mode
        cards.sort(function(a, b) {
            var diff = 0;
            if (currentSort === 'published_at asc') {
                diff = a._ts - b._ts; // Oldest first
                return diff !== 0 ? diff : (b._i - a._i); 
            } else {
                diff = b._ts - a._ts; // Newest first
                return diff !== 0 ? diff : (a._i - b._i); 
            }
        });
        
        cards.forEach(function(card, index) {
            // Apply sorted flex order
            card.style.order = index;
            card.style.animation = 'none'; 
            card.style.opacity = '1';
            
            // Filter Phase
            var show = true;
            if (currentFilter !== 'all') {
                var filterClass = 'tag-' + currentFilter;
                if (!card.classList.contains(filterClass)) {
                    show = false;
                }
            }
            
            // Toggle Display
            if (show) {
                card.style.display = 'flex';
                visibleCount++;
            } else {
                card.style.display = 'none';
            }
        });
        
        // Update helper UI
        if (resultsEl) {
            resultsEl.textContent = visibleCount === 1 ? '1 report' : visibleCount + ' reports';
        }
        
        // Hide pagination if a filter/sort modifies default view, 
        // as DOM filtering cannot accurately track off-page counts.
        if (paginationEl) {
            paginationEl.style.display = (currentFilter !== 'all' || currentSort !== 'published_at desc') ? 'none' : 'block';
        }
    }

    // 4. EVENT LISTENERS
    // Trigger grid updates on selector changes.
    if (sortSelect && filterSelect) {
        sortSelect.addEventListener('change', function (e) {
            currentSort = e.target.value;
            applyDOMFilterAndSort();
        });
        filterSelect.addEventListener('change', function (e) {
            currentFilter = e.target.value;
            applyDOMFilterAndSort();
        });
    }

});
